import React, { useState, useEffect } from "react";
import { Sidebar, Menu, MenuItem } from "react-pro-sidebar";
import { BellIcon, Cog6ToothIcon } from "@heroicons/react/24/solid";
import { AnalyticsIcon } from "./Icons/AnalyticsIcon";
import { useNavigate } from "react-router-dom";
import {
  ArrowLeftIcon,
  ArrowRightIcon,
  Bars3Icon,
} from "@heroicons/react/24/solid";
import { useTranslation } from "react-i18next";
import { Colors } from "../constants/Colors";

export const LayoutSidebar = () => {
  const [hovered, setHovered] = useState(null);
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isMinimizeTextVisible, setIsMinimizeTextVisible] = useState(true);
  const [isSidebarVisible, setIsSidebarVisible] = useState(true);
  const navigate = useNavigate();
  const { t } = useTranslation();

  const toggleSidebar = () => {
    setIsSidebarOpen((prev) => !prev);
  };

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen((prev) => !prev);
  };

  const handleMouseEnter = (index) => {
    setHovered(index);
  };

  const handleMouseLeave = () => {
    setHovered(null);
  };

  const handleTransitionEnd = () => {
    if (!isSidebarOpen) {
      setIsMinimizeTextVisible(false);
    } else {
      setIsMinimizeTextVisible(true);
    }
  };

  const menuItemStyle = (index, active) => ({
    backgroundColor:
      active || hovered === index ? "rgb(50, 120, 180)" : "transparent",
    color: active ? "#FFFFFF" : "#c5c5c5",
    fontFamily: "Open sans, sans-serif",
    fontWeight: active ? "bold" : "inherit",
    width: "80%",
    margin: "0 auto",
    paddingLeft: "5px",
    borderRadius: active || hovered === index ? "10px" : "0",
    marginBottom: "5px",
  });

  const menuItemStyleMobile = (index, active) => ({
    backgroundColor: active ? "rgb(50, 120, 180)" : "transparent",
    color: active ? "#FFFFFF" : "#c5c5c5",
    fontFamily: "Open sans, sans-serif",
    fontWeight: active ? "bold" : "inherit",
    width: "100%",
    paddingLeft: "5px",
    borderRadius: active ? "10px" : "0",
    marginBottom: "5px",
  });

  const menuItems = [
    {
      title: t("general.analytics"),
      icon: <AnalyticsIcon style={{ width: "24", height: "24" }} />,
      active: window.location.pathname === "/analytics",
      path: "/analytics",
    },
    {
      title: t("general.settings"),
      icon: <Cog6ToothIcon style={{ width: "24", height: "24" }} />,
      active: window.location.pathname === "/settings",
      path: "/settings",
    },
  ];

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth <= 768) {
        setIsSidebarOpen(false);
        if (window.innerWidth <= 600) {
          setIsSidebarVisible(false);
        }
      } else {
        setIsSidebarVisible(true);
        setIsSidebarOpen(true);
        setIsMobileMenuOpen(false);
      }
    };
    window.addEventListener("resize", handleResize);
    handleResize();
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <div style={{ display: "flex", height: "100%" }}>
      {isSidebarVisible && (
        <Sidebar
          backgroundColor={Colors.primary100}
          collapsed={!isSidebarOpen}
          collapsedWidth="60px"
          onTransitionEnd={handleTransitionEnd}
          width="220px"
        >
          <Menu>
            <div style={{ height: "75px" }}></div>
            {menuItems.map(({ title, icon, active, path }, idx) => (
              <MenuItem
                icon={icon}
                key={idx}
                style={menuItemStyle(idx, active)}
                active={active}
                onMouseEnter={() => handleMouseEnter(idx)}
                onMouseLeave={() => handleMouseLeave(idx)}
                onClick={() => {
                  if (!active) navigate(path);
                }}
              >
                {isSidebarOpen && title}
              </MenuItem>
            ))}
          </Menu>
          <div
            className="absolute bottom-1 left-0 w-full text-center"
            style={{ width: "100%" }}
            onMouseEnter={() => handleMouseEnter(menuItems.length)}
            onMouseLeave={() => handleMouseLeave(menuItems.length)}
          >
            <div
              style={{
                ...menuItemStyle(menuItems.length, false),
                padding: "10px",
                cursor: "pointer",
                display: "flex",
                gap: "16px",
              }}
              onClick={toggleSidebar}
            >
              {isSidebarOpen ? (
                <ArrowLeftIcon width="24px" />
              ) : (
                <ArrowRightIcon width="24px" />
              )}
              {isMinimizeTextVisible &&
                isSidebarOpen &&
                t("general.minimizeMenu")}
            </div>
          </div>
        </Sidebar>
      )}

      {!isSidebarVisible && (
        <div
          style={{
            position: "fixed",
            top: "8px",
            left: "10px",
            color: Colors.primary100,
            padding: "10px",
            borderRadius: "5px",
            cursor: "pointer",
            zIndex: 3000,
          }}
          className="bars3icon"
          onClick={toggleMobileMenu}
        >
          <Bars3Icon width="30px" color={Colors.primary100} fontWeight={1000} />
        </div>
      )}

      {/* Mobile Dropdown Menu */}
      {isMobileMenuOpen && (
        <div
          style={{
            position: "absolute",
            top: "60px",
            left: "10px",
            backgroundColor: Colors.primary100,
            color: "white",
            borderRadius: "10px",
            width: "175px",
            padding: "10px",
            zIndex: 3000,
          }}
        >
          <Menu>
            {menuItems.map(({ title, icon, active, path }, idx) => (
              <MenuItem
                icon={icon}
                key={idx}
                style={menuItemStyleMobile(idx, active)}
                active={active}
                onClick={() => {
                  navigate(path);
                  setIsMobileMenuOpen(false); // Close dropdown after navigation
                }}
              >
                {title}
              </MenuItem>
            ))}
          </Menu>
        </div>
      )}
    </div>
  );
};
